import { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import logo from "../../assets/img/logo.png";
import wsp from "../../assets/img/wsp.png";

const Header = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 400,
      behavior: "smooth",
    });
  };

  return (
    <Container fluid className="sticky-top header-new">
      <Row>
        <Container fluid className="header">
          <Container>
            <Row>
              <Col
                md={4}
                xs={12}
                className="d-flex justify-content-center align-content-center align-items-center flex-column"
              >
                <div onClick={() => scrollToTop()} style={{ cursor: "pointer" }}>
                  <img src={logo} alt="Montironi Ford" />
                </div>
              </Col>
              <Col md={8} xs={12} className="d-md-flex justify-content-end d-none ">
                <a
                  href={"#versiones"}
                  target={"_self"}
                  rel="noreferrer"
                  className="btn-transparent me-md-2 ps-4 pe-4"
                  style={{ cursor: "pointer", textDecoration: "none" }}
                >
                  Versiones
                </a>
                <a
                  href={"#form"}
                  target={"_self"}
                  rel="noreferrer"
                  className="btn-blue ps-5 pe-5"
                  style={{ cursor: "pointer", textDecoration: "none", color: "white" }}
                >
                  Cotizar
                </a>
                {/* <Button
                  className="btn-blue ps-5 pe-5"
                  onClick={() =>
                    window.open(
                      "https://api.whatsapp.com/send?phone=+5493517915708&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Nueva%20Ranger"
                    )
                  }
                >
      
                  Cotizar
                </Button> */}
              </Col>
            </Row>
          </Container>
        </Container>
      </Row>
    </Container>
  );
};

export default Header;
